<template>
  <q-page padding>
    <PageHeader
      title="Ativar controle de Lote"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    >
      <template #actions>
        <q-icon
          style="cursor: pointer"
          name="info"
          size="xs"
          @click="activeSlide = !activeSlide"
          class="text-brand-1 q-ml-xs"
        />
      </template>
    </PageHeader>

    <infot-upload
      :activeSlide="activeSlide"
      :link="'https://multpex-docs.s3.amazonaws.com/templates/estoque/template_ativar_controle_estoque_r1.xlsx'"
      :infos="infos"
    />

    <div class="upload-section">
      <div class="upload-header">
        <q-icon name="upload_file" size="24px" class="header-icon" />
        <h6 class="upload-title">
          Enviar planilha para ativar controle de lote
        </h6>
      </div>
      <div class="upload-content">
        <div
          class="upload-area"
          :class="{ 'file-selected': file, 'drag-over': isDragOver }"
          @dragover.prevent="isDragOver = true"
          @dragleave.prevent="isDragOver = false"
          @drop.prevent="onDrop"
        >
          <div class="upload-zone">
            <div class="upload-icon-container">
              <q-icon name="cloud_upload" size="48px" class="upload-icon" />
            </div>
            <div class="upload-text-container">
              <p class="upload-main-text" v-if="!file">
                Arraste e solte sua planilha aqui ou
              </p>
              <p class="upload-main-text selected" v-else>
                <q-icon name="description" class="q-mr-xs" />{{ file.name }}
              </p>
              <div class="upload-button">
                <q-btn
                  :color="file ? 'positive' : 'primary'"
                  :icon="file ? 'check_circle' : 'folder_open'"
                  :label="file ? 'Arquivo Selecionado' : 'Selecionar Arquivo'"
                  no-caps
                  rounded
                  class="upload-btn"
                  @click="fileInput.click()"
                />
                <input
                  ref="fileInput"
                  type="file"
                  accept=".xlsx,.xls"
                  @change="onFileSelected"
                  style="display: none"
                />
              </div>
            </div>
          </div>
          <div class="file-info" v-if="file">
            <div class="file-details">
              <q-chip color="primary" text-color="white" icon="info"
                >Tamanho: {{ formatFileSize(file.size) }}</q-chip
              >
              <q-chip color="positive" text-color="white" icon="event"
                >Tipo: {{ file.type || "Excel" }}</q-chip
              >
            </div>
          </div>
        </div>
        <div class="upload-actions">
          <q-btn
            color="positive"
            label="Enviar Planilha"
            no-caps
            icon="send"
            size="md"
            :disable="!file"
            @click="enviarTemplate"
            class="send-button"
          />
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import InfotUpload from "../../compras/components/InfotUpload.vue";
import PageHeader from "../../../../components/PageHeader.vue";

export default {
  components: { InfotUpload, PageHeader },
  setup() {
    const $q = useQuasar();
    const store = useStore();
    const file = ref(null);
    const fileInput = ref(null);
    const isDragOver = ref(false);
    const activeSlide = ref(false);

    const infos = ref([
      {
        name: "Para esse serviço é necessário somente o código do Item",
        icon: "do_not_disturb",
      },
      { name: "Não crie nenhuma outra coluna", icon: "delete" },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "view_column",
      },
    ]);

    const formatFileSize = (bytes) => {
      if (!bytes) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    };

    const onFileSelected = (e) => {
      if (e.target.files[0]) file.value = e.target.files[0];
    };

    const onDrop = (e) => {
      isDragOver.value = false;
      const f = e.dataTransfer.files[0];
      if (f && f.name.endsWith(".xlsx")) {
        file.value = f;
      } else {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
      }
    };

    const enviarTemplate = async () => {
      if (!file.value || !file.value.name.endsWith(".xlsx")) {
        $q.notify({
          message: "Por favor, selecione apenas arquivos .xlsx",
          color: "negative",
          icon: "warning",
        });
        return;
      }

      $q.loading.show({ message: "Enviando planilha..." });

      try {
        const result = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file.value);
          reader.onload = () => resolve(reader.result);
          reader.onerror = () => reject(reader.error);
        });

        await store.dispatch("estoque/upload", {
          planilha: result,
          mapeamento: "ativacao_lote",
          adicional: { vendor_id: store.state.org.unidadeData.id },
        });

        $q.loading.hide();
        $q.notify({
          message: "Enviado com sucesso",
          color: "positive",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
        file.value = null;
      } catch (error) {
        $q.loading.hide();
        console.log(error);
        $q.notify({
          message: "Erro ao enviar",
          color: "negative",
          actions: [{ label: "Fechar", color: "white", handler: () => {} }],
        });
      }
    };

    return {
      enviarTemplate,
      file,
      fileInput,
      isDragOver,
      activeSlide,
      infos,
      formatFileSize,
      onFileSelected,
      onDrop,
    };
  },
};
</script>

<style scoped>
.upload-section {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  border-radius: 16px;
  padding: 24px;
  margin: 16px 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.upload-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 12px;
}

.header-icon {
  color: #1976d2;
}

.upload-title {
  margin: 0;
  color: #2c3e50;
  font-weight: 600;
  font-size: 1.1rem;
}

.upload-content {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.upload-area {
  background: white;
  border: 2px dashed #e0e4e7;
  border-radius: 12px;
  padding: 32px;
  text-align: center;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.upload-area:hover {
  border-color: #1976d2;
  background: #f8fafe;
  transform: translateY(-2px);
  box-shadow: 0 4px 20px rgba(25, 118, 210, 0.1);
}

.upload-area.file-selected {
  border-color: #4caf50;
  background: #f1f8e9;
}

.upload-area.drag-over {
  border-color: #1976d2;
  background: #e3f2fd;
  transform: scale(1.02);
}

.upload-zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.upload-icon-container {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

.upload-icon {
  color: white;
}

.upload-text-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.upload-main-text {
  margin: 0;
  color: #546e7a;
  font-size: 1rem;
  font-weight: 500;
}

.upload-main-text.selected {
  color: #2e7d32;
  font-weight: 600;
}

.upload-button {
  cursor: pointer;
}

.upload-btn {
  min-width: 180px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.upload-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.file-info {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid #e0e4e7;
}

.file-details {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.upload-actions {
  display: flex;
  justify-content: center;
}

.send-button {
  min-width: 160px;
  height: 44px;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.2s ease;
}

.send-button:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}
</style>
